import { useNavigate } from 'react-router-dom';
import MenuDropDown from './Elements/MenuDropdown';
import { useTheme } from '../utils/themeUtils';
import { classNames } from '../utils/utils';
import { MainLogo } from '../utils/iconFactory';

function Header({children}: any) {
  const navigate = useNavigate();
  const { themeString } = useTheme();

  {  }

  return (
    <div id='header-div' className={classNames('absolute top-0 inset-x z-30 w-full flex justify-between h-[86px] rounded-b-[16px] px-10 py-4 bg-backgroundWhite shadow', themeString)}>
      <button id='main-logo-button' onClick={() => navigate('/')}>
        <MainLogo/>
      </button>
      <div id='header-children' className='flex justify-center items-center'>
        {children}
      </div>
      <div id='menu-chip-div' className="flex items-center">
        <MenuDropDown/>
      </div>
    </div>
  )
}

export default Header;
